/*
  Sparko cart bridge (2026-10-14). Lets the Sparko customizer app block add to cart through this theme's own
  flow, exactly as the native product form does (assets/island-product.bundle.js, ProductForm.submit): one
  /cart/add request that also asks for the cart sections (getCartSectionRequestIds, assets/utils.js), then
  `shapes:cart:afteradditem` on document.body with the line and those sections. The theme's listeners do the
  rest: the header count updates and the cart drawer re-renders and opens.

  window.SparkoThemeCart.add(items) -> Promise of Shopify's /cart/add.js response; rejects with Shopify's message.
  Loaded only where the customizer is (sections/sparko-pdp-buy.liquid).
*/
(function () {
  if (window.SparkoThemeCart) return;

  window.SparkoThemeCart = {
    version: 1,
    async add(items) {
      const sections =
        typeof getCartSectionRequestIds === 'function' ? getCartSectionRequestIds() : [];
      const response = await fetch(`${window.theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json().catch(() => null);

      if (!response.ok || !data || data.status) {
        throw new Error(
          (data && (data.description || data.message)) ||
            "We couldn't add this to your cart. Please try again."
        );
      }

      // The native form adds one line and gets that line back; an items array gets { items, sections }.
      const line = (data.items && data.items[data.items.length - 1]) || data;
      document.body.dispatchEvent(
        new CustomEvent('shapes:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: { ...line, sections: data.sections },
            sourceId: null,
          },
        })
      );
      return data;
    },
  };
})();
